import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(m, { ...r, children: /* @__PURE__ */ o("path", { d: "M10.0808 2.57196c-4.14023 0-7.50884 3.36861-7.50884 7.50884 0 4.1485 3.36031 7.5088 7.50884 7.5088 4.1485 0 7.5088-3.3603 7.5088-7.5088.0083-4.14023-3.3603-7.50884-7.5088-7.50884Zm2.8874 11.29234-2.8791-2.8791-2.88738 2.8874-.88779-.8878 2.88738-2.8874-2.88738-2.88738.88779-.88779 2.87908 2.88738 2.8708-2.87079.8961.87949-2.8708 2.87079 2.8791 2.8791-.8878.8961Z" }) });
export {
  p as ClearSymbol
};
//# sourceMappingURL=ClearSymbol.js.map
